import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Hub } from 'aws-amplify/utils';
// import { signOut, fetchUserAttributes, signInWithRedirect } from 'aws-amplify/auth';
import { environment } from '@environments/environment';
import { AuthService } from '@shared/services/guards/auth.service';
import { RouteService } from '@shared/services/guards/route.service';
import { ContractorService } from '@shared/services/contractor.service';
import { AmplifyAuthService } from '@app/shared/services/amplifyAuth.service';
export const CONTRACTOR_ID = 'contractorID'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {
  loading = false;
  prevURL = localStorage.getItem('prev_url');
  private authHubListener: any; // Keep reference to unsubscribe

  constructor(
    private router: Router,
    private routeService: RouteService,
    private authService: AuthService,
    private ngZone: NgZone,
    private contractorService: ContractorService,
    private _authService: AuthService,
    private amplifyAuthService: AmplifyAuthService,
  ) {}

  async ngOnInit() {
    if (this.routeService.getPreviousUrl() === '/login') {
      this.routing();
    } else {
      this.loading = true;
      Hub.listen('auth', (data) => {
        console.log('auth event received:', data);
        switch (data.payload.event) {
          case 'signedIn':
            console.log('User is signed in');
            this.routing();
            break;
          case 'signInWithRedirect_failure':
            console.log('User sign-in failed');
            this.routing();
            break;
          default:
            break;
        }
      });
    }
  }


  // data = user PROFILE
  async routing() {
    // Simplify the observable subscription
    this.authService.isVerified().subscribe({
      next: (data) => {
        this.validateContractorinPool(data);
      },
      error: (e) => {
        this.update(false, null);
        this.router.navigate(['/error']);
      }
    });
  }

  async update(isAuthenticated, id) {
    this.amplifyAuthService.fetchUserAttributes().then( async (data) => {
      localStorage.setItem('userEmail', data.email);
      localStorage.setItem(CONTRACTOR_ID, id);

      if (isAuthenticated) {
        if (this.prevURL !== undefined && this.prevURL !== '/service-request/search') {
          localStorage.removeItem('prev_url');
          this.ngZone.run(() => this.router.navigateByUrl(this.prevURL));
        } else {
          this.ngZone.run(() => this.router.navigate([environment.contractor_home]));
        }
      } else {
        this.amplifyAuthService.signOut();
        localStorage.clear();
        // window.location.replace(environment.signOut);
        this.amplifyAuthService.signInWithRedirect()
      }
    });
  }

  validateContractorinPool(data) {
    const email = data.email;
    this.contractorService.getContractor(email).subscribe({
      next: (profile) => {

        const res = profile['body'];
        localStorage.setItem('cbmName', res['cbmName']);
        localStorage.setItem('email', res['cbmEmail']);
        this.update(true, res['uuid']);
      },
      error: () => {
        this.update(false, null);
      }
    });
  }
}
